export default __webpack_public_path__ + "static/banner_img-277a38433c873c57b976281c68827a20.jpg";